(function () {
  var MIN = 15000;

  // Inject tooltip CSS once
  var styleInjected = false;
  function injectStyle() {
    if (styleInjected) return;
    styleInjected = true;
    var s = document.createElement('style');
    s.textContent =
      '#fm-btn-wrap { position: relative; display: block; width: 100%; }' +
      '#fm-btn-wrap[data-tip]:hover::after {' +
        'content: attr(data-tip);' +
        'position: absolute;' +
        'bottom: calc(100% + 8px);' +
        'left: 50%;' +
        'transform: translateX(-50%);' +
        'background: #222;' +
        'color: #fff;' +
        'font-size: 12px;' +
        'padding: 6px 12px;' +
        'border-radius: 4px;' +
        'white-space: nowrap;' +
        'pointer-events: none;' +
        'z-index: 100;' +
      '}' +
      '#fm-btn-wrap[data-tip]:hover::before {' +
        'content: "";' +
        'position: absolute;' +
        'bottom: calc(100% + 3px);' +
        'left: 50%;' +
        'transform: translateX(-50%);' +
        'border: 5px solid transparent;' +
        'border-top-color: #222;' +
        'pointer-events: none;' +
        'z-index: 100;' +
      '}';
    document.head.appendChild(s);
  }

  function getOrCreateWrap(btn) {
    var wrap = document.getElementById('fm-btn-wrap');
    if (!wrap) {
      injectStyle();
      wrap = document.createElement('span');
      wrap.id = 'fm-btn-wrap';
      btn.parentNode.insertBefore(wrap, btn);
      wrap.appendChild(btn);
    }
    return wrap;
  }

  function applyMinOrder(cartTotal) {
    var below = cartTotal < MIN;
    var drawerBtn = document.getElementById('CartDrawer-Checkout');
    if (drawerBtn) {
      drawerBtn.disabled = below;
      var wrap = getOrCreateWrap(drawerBtn);
      if (below) {
        var rem = Math.ceil((MIN - cartTotal) / 100);
        wrap.setAttribute('data-tip', 'Lägg till ' + rem + ' kr till för att gå till kassan');
      } else {
        wrap.removeAttribute('data-tip');
      }
    }
    var cartBtn = document.getElementById('checkout');
    if (cartBtn) cartBtn.disabled = below;
    // Varukorgssidan ritar inte om snabbkassan när antalet ändras, så den döljs här.
    var express = document.querySelector('.cart__dynamic-checkout-buttons');
    if (express) express.hidden = below;
  }

  function check() {
    fetch('/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (c) { applyMinOrder(c.items_subtotal_price || c.total_price || 0); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }

  // Temat meddelar varukorgsändringar via pubsub.js, inte som DOM-händelser.
  subscribe(PUB_SUB_EVENTS.cartUpdate, check);

  var lastBtn = null;
  var observer = new MutationObserver(function () {
    var btn = document.getElementById('CartDrawer-Checkout');
    if (btn && btn !== lastBtn) { lastBtn = btn; check(); }
  });

  var drawer = document.getElementById('CartDrawer');
  if (drawer) {
    observer.observe(drawer, { childList: true, subtree: true });
  } else {
    var bodyObs = new MutationObserver(function () {
      var d = document.getElementById('CartDrawer');
      if (d) {
        bodyObs.disconnect();
        observer.observe(d, { childList: true, subtree: true });
        check();
      }
    });
    bodyObs.observe(document.body, { childList: true, subtree: false });
  }
})();
